// Both the API path and transport policy are explicitly configured. First-party
// routing uses the same ingress as the page; no tokens enter browser storage.
export const resolveApiBase = (backendUrl, mode, pageOrigin) => {
  if (!backendUrl) throw new Error('REACT_APP_BACKEND_URL is required');
  if (!['same-origin', 'configured-origin'].includes(mode)) {
    throw new Error('REACT_APP_API_MODE must be same-origin or configured-origin');
  }
  const configured = new URL(backendUrl);
  const path = `${configured.pathname.replace(/\/$/, '')}/api`;
  return new URL(path, mode === 'same-origin' ? pageOrigin : configured.origin).href;
};